import {useEffect} from 'react';
import { showLoader, useUiStore } from '@/stores/ui.store.ts';


export function useGlobalLoader(isLoading = false) {
  const loader = useUiStore(state => state.loader);
  useEffect(() => {
    if (isLoading != loader) {
      showLoader(isLoading);
    }
  }, [isLoading]);

  const preventDialogClose = () => ({
    onPointerDownOutside: (e: any) => {
      if (document.body.classList.contains('loading')) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    onEscapeKeyDown: (e: any) => {
      if (document.body.classList.contains('loading')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });
  return {
    showLoader,
    preventDialogClose,
  };
}